import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import { defaultStoreUtils } from '@databases/redux';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import { useScope } from '@databases/scope';
import { getDatabaseFieldRequired } from '@databases/utils/database/utils';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

export const FieldNameViewContainer = styled.span`
  color: ${token('color.text.subtlest', '#626F86')};
`;

export interface FieldNameViewProps {
  fieldId: string;
  contentId: string;
}

/**
 * Renders the name of a database field. If the name is empty, a placeholder is shown.
 */
const FieldNameView: FunctionComponent<FieldNameViewProps> = ({ fieldId, contentId }) => {
  const scope = useScope();
  const { formatMessage } = useIntl();

  const value = defaultStoreUtils.useEqualSelector((state) => {
    const databaseDraft = selectDatabaseDraftByContentId(state, {
      contentId,
      scope,
      includeDeleted: true,
    });
    const field = getDatabaseFieldRequired(databaseDraft, fieldId);
    return field?.name || formatMessage(messages['field.default-field-name']);
  });

  return <FieldNameViewContainer>{value}</FieldNameViewContainer>;
};

export default FieldNameView;
